export default "__VITE_ASSET__CwS6DgiP__"